/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_SecondsInputs */

const en_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seconds (ss.mmm)`)
};

const fr_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`secondes (ss.mmm)`)
};

const de_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunden (ss.mmm)`)
};

const it_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`secondi (ss.mmm)`)
};

const ru_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`секунд (сс.ммм)`)
};

const es_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`segundos (ss.mmm)`)
};

const zh_cn2_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒（ss.mmm）`)
};

const ja_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒（ss.mmm）`)
};

const hi_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेकंड (एसएस.म्म)`)
};

const pt_pt2_transcript_export_timecode_format_seconds = /** @type {(inputs: Transcript_Export_Timecode_Format_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`segundos (ss.mmm)`)
};

/**
* | output |
* | --- |
* | "seconds (ss.mmm)" |
*
* @param {Transcript_Export_Timecode_Format_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_seconds = /** @type {((inputs?: Transcript_Export_Timecode_Format_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_timecode_format_seconds(inputs)
	if (locale === "de") return de_transcript_export_timecode_format_seconds(inputs)
	if (locale === "it") return it_transcript_export_timecode_format_seconds(inputs)
	if (locale === "ru") return ru_transcript_export_timecode_format_seconds(inputs)
	if (locale === "es") return es_transcript_export_timecode_format_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_timecode_format_seconds(inputs)
	if (locale === "ja") return ja_transcript_export_timecode_format_seconds(inputs)
	if (locale === "hi") return hi_transcript_export_timecode_format_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_timecode_format_seconds(inputs)
	return en_transcript_export_timecode_format_seconds(inputs)
});